import { defineComponent } from '@vue/composition-api';
import __vue_component__ from '../content/CustomImage.vue.js';
import { IconType } from './enums.js';

/**
 * @deprecated Use SdsFlag instead
 */
var script = defineComponent({
    name: 'SbFlagIcon',
    props: {
        flag: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            required: false,
            default: 'small',
        },
        icon: {
            type: String,
            required: false,
            default: '',
        },
        hasBorder: {
            type: Boolean,
            default: true,
        },
        iconImgSrc: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup: function () {
        return {
            IconType: IconType,
        };
    },
    components: {
        CustomImage: __vue_component__,
    },
});

export default script;
